import React, { useEffect, useState } from 'react'
import { Tabs } from 'antd';
import { DetailContainer, TabImg, TabHead, TabTitle, TabPaneItem } from '../../../StyledComponents/CreateKeyAccountManager'
import { MinimumMarkup } from './MinimumMarkup';
import { Simulator } from './Simulator';
import { ODCCStrategies } from './ODCStrategies';
import { CustomerCategory } from './CustomerCategory';
import { TabItem } from '../../../StyledComponents/Markup';
import { useDispatch, useSelector } from 'react-redux';
import { getcustomercategorylist,getAirlinesList,getAirportList,getOdccStrategiesList, getMinimumMarkupList } from "../../../store/Markup/markupSlice"

const { TabPane } = Tabs;
function MarkupDetails(props) {
    
    const [currentTab, setCurrentTab] = useState("1");
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getcustomercategorylist());
        dispatch(getAirlinesList());
        dispatch(getAirportList());
        dispatch(getOdccStrategiesList());
        dispatch(getMinimumMarkupList());
    }, [])
    const callback = (key) => {
        setCurrentTab(key)
    }


    const items = [
        {
            key: '1',
            tab: (
                <TabHead>
                    {/* {currentTab === "1" ? <TabImg src={require('../../../assets/admin/images/user-squaretab_active.png')} /> : <TabImg src={require('../../../assets/admin/images/user-squaretab.png')} />} */}
                    <TabTitle active={currentTab === "1"}>
                        Minimum Markup
                    </TabTitle>
                </ TabHead>
            ),
            content: <MinimumMarkup note="A positive minimum markup represent minimum profit whereas a negative minimum markup
represent maximum loss." />,
        },
        {
            key: '2',
            tab: (
                <TabHead>
                    {/* {currentTab === "2" ? <TabImg src={require('../../../assets/admin/images/finger-scantab_active.png')} /> : <TabImg src={require('../../../assets/admin/images/finger-scantab.png')} />} */}
                    <TabTitle active={currentTab === "2"}>
                        Customer Category
                    </TabTitle>
                </ TabHead>
            ),
            content: <CustomerCategory />,
        },
        // ODCC Strategies tab hidden
        // {
        //     key: '3',
        //     tab: (
        //         <TabHead>
        //             <TabTitle active={currentTab === "3"}>
        //                 ODCC Strategies
        //             </TabTitle>
        //         </ TabHead>
        //     ),
        //     content: <ODCCStrategies />,
        // },
        {
            key: '4',
            tab: (
                <TabHead>
                    {/* {currentTab === "4" ? <TabImg src={require('../../../assets/admin/images/finger-scantab_active.png')} /> : <TabImg src={require('../../../assets/admin/images/finger-scantab.png')} />} */}
                    <TabTitle active={currentTab === "4"}>
                        Simulator
                    </TabTitle>
                </ TabHead>
            ),
            content: <Simulator />,
        },
    ];
    return (
        <DetailContainer className='user-management'>
            <TabItem
                tabPosition="left"
                defaultActiveKey={props.tab ? props.tab : "1"}
                onChange={callback}
                items={items.map((i, idx) => {
                    const id = String(idx + 1);
                    return {
                        label: i.tab,
                        key: i.key,
                        children: i.content,
                    };
                })}
            />
        </DetailContainer>
    )
}

export default MarkupDetails
